import React from "react";
import MailingResources from "../../components/fullfillment/mailing-resources";

export const Agents = () => {
  return (
<MailingResources source={'agent'} status='New' />
  );
};

export default Agents;